import { render, staticRenderFns } from "./ExcludePlans.vue?vue&type=template&id=37399d50&lang=pug"
import script from "./ExcludePlans.vue?vue&type=script&lang=js"
export * from "./ExcludePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports